import { Factory } from '../../services/Factory';

namespace app.directives.utilities {
  export class Scrolling implements angular.IDirective {
    public restrict = 'A';
    public link: (scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => void;

    constructor() {
      this.link = (scope: angular.IScope, element: angular.IAugmentedJQuery, attrs: angular.IAttributes) => {
        let domElement = element.get(0);
        let isMacWebkit = navigator.userAgent.indexOf("Macintosh") !== -1 && navigator.userAgent.indexOf("WebKit") !== -1;
        let isFirefox = navigator.userAgent.indexOf("firefox") !== -1;
        let wheelHandler = (event) => {
          let e = event || window.event;

          // Modern WheelEvent uses deltaMode: 0=pixels, 1=lines, 2=pages.
          // Older events use wheelDelta (inverted sign, large magnitude) or detail.
          let isModernWheel = 'deltaMode' in e;
          let getDeltaScale = (evt: any) => evt.deltaMode === 1 ? 30 : evt.deltaMode === 2 ? 500 : 1;

          let deltaX = isModernWheel
            ? e.deltaX * -getDeltaScale(e)
            : (e.wheelDeltaX / 4 || 0);
          let deltaY = isModernWheel
            ? e.deltaY * -getDeltaScale(e)
            : (e.wheelDeltaY / 4 || (e.wheelDeltaY === undefined && e.wheelDelta / 4) || e.detail * -10 || 0);

          // Only apply Mac WebKit normalization for legacy wheel events:
          // modern WheelEvent already reports correct pixel deltas on Mac.
          if (isMacWebkit && !isModernWheel) {
            deltaX /= 30;
            deltaY /= 30;
          }

          e.currentTarget.scrollTop -= deltaY;
          e.currentTarget.scrollLeft -= deltaX;

          if (isFirefox && e.type !== "DOMMouseScroll")
            domElement.removeEventListener("DOMMouseScroll", wheelHandler, false);
          if (e.preventDefault) e.preventDefault();
          if (e.stopPropagation) e.stopPropagation();
          e.cancelBubble = true;
          e.returnValue = false;

          return false;
        };

        domElement.onwheel = wheelHandler;
        (<any>domElement).onmousewheel = wheelHandler;

        if (isFirefox) {
          domElement.scrollTop = 0;
          domElement.addEventListener("DOMMouseScroll", wheelHandler, false);
        }
      }
    }
  }

  frontendApp.directive("iioStopScrolling", [Factory.Create(Scrolling)]);
}
